export var PROGRAM_DETAIL_DRAWER_TAB = {
    STUDENTS_BELOW_850: 'students-below-850',
    SHERPATH_ENGAGEMENT: 'sherpath-engagement',
    PRESCRIPTION_FOR_SUCCESS: 'prescription-for-success',
    SHERPATH_AI: 'sherpath-ai'
};
export var PROGRAM_DETAIL_TAB = {
    HESI: 'hesi',
    SHERPATH: 'sherpath',
    SHADOW_HEALTH: 'shadow-health',
    SHERPATH_AI: 'sherpath-ai'
};
export var SherpathCardId;
(function (SherpathCardId) {
    SherpathCardId["ENGAGEMENT"] = "engagement";
    SherpathCardId["EAQ_SELF_STUDY"] = "eaq-self-study";
    SherpathCardId["PRESCRIPTION_FOR_SUCCESS"] = "prescription-for-success";
})(SherpathCardId || (SherpathCardId = {}));
export var PrescriptionMetricKey;
(function (PrescriptionMetricKey) {
    PrescriptionMetricKey["SherpathLessons"] = "sherpathLessons";
    PrescriptionMetricKey["Eaqs"] = "eaqs";
    PrescriptionMetricKey["Simulations"] = "simulations";
})(PrescriptionMetricKey || (PrescriptionMetricKey = {}));
export var SherpathAiTimeWindow;
(function (SherpathAiTimeWindow) {
    SherpathAiTimeWindow["ThisWeek"] = "this_week";
    SherpathAiTimeWindow["LastWeek"] = "last_week";
    SherpathAiTimeWindow["ThisMonth"] = "this_month";
    SherpathAiTimeWindow["ThisSemester"] = "this_semester";
})(SherpathAiTimeWindow || (SherpathAiTimeWindow = {}));
